import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AddProjectPayload, Projects } from '../Modules/idms/components/project-manager/models/project.model';
import {
    AddactivityPackTaggedItemActivity,
    ProjectActivityPackDetails,
} from '../Modules/idms/components/project-manager/models/ProjectActivityPackDetails.model';
import { ProjectsDetails, activityPacks, activitypacktaggeditems } from '../Modules/idms/components/project-manager/models/projectDetails.model';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APIRes } from '../Modules/idms/models/commonAPI.model';
import { SearchedProject } from '../Modules/idms/components/idms/idms-site-search/models/siteSearchTaggedItemModel';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class ParamsApiService {
    headers: HttpHeaders;

    private paramApi = environment.paramsApi;
    private subVal = '';
    private logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;

    constructor(
        private http: HttpClient,
        private authService: MsalService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights
    ) {
        this.subVal = this.EnvironmentService.getConfig().subValue;
    }

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('Accept', 'application/json;');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*/*');
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('instanceId', `${localStorage.getItem('currentInstanceId')}`);
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
    }

    private createHttpParams(params: {}): HttpParams {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach((param) => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });

        return httpParams;
    }

    //Method for getting all projects
    getAllProjects(): Observable<APIRes<Projects[]>> {
        const url = `${this.paramApi}projects/getprojects`; //`
        this.addPostAndPutHeaders();
        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting Project details
    getProjectsDetails(projectId: string): Observable<APIRes<ProjectsDetails>> {
        const url = `${this.paramApi}projects/${projectId}`;
        this.addPostAndPutHeaders();
        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //method for adding project
    addProject(project: AddProjectPayload): Observable<APIRes<Projects>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.paramApi}projects`, project, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //method for copy project
    copyProject(project: AddProjectPayload): Observable<APIRes<Projects>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.paramApi}projects/copy`, project, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //method for updating project
    UpdateProject(project: any): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.paramApi}projects`, project, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //method for delete project
    deleteProject(payload: any): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.paramApi}projects`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // api call to update the project types
    projectsToggleFavourite(payload: any): Observable<APIRes<ProjectActivityPackDetails[]>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.paramApi}projects/favourite`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting Project details
    getActivityPackDetails(activityPackId: string): Observable<APIRes<ProjectActivityPackDetails>> {
        const url = `${this.paramApi}activitypacks/${activityPackId}`; //`
        this.addPostAndPutHeaders();
        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for adding activitypack with in project
    addActivityPackWithInProject(projectId: string, activityPack): Observable<APIRes<activityPacks>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.paramApi}activitypacks/${projectId}`, activityPack, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //Method for copy activitypack with in project
    copyActivityPackWithInProject(projectId: string, activityPack): Observable<APIRes<activityPacks>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.paramApi}activitypacks/copy/${projectId}`, activityPack, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //Method for Updating activitypack with in project
    UpdateActivityPackWithInProject(projectId: any, activityPack): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.paramApi}/activitypacks/${projectId}`, activityPack, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // method for  Favourite and Un-favourite work-pack
    workpackToggleFavourite(payload: any): Observable<APIRes<activityPacks[]>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.paramApi}activitypacks/favourite`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for adding Tag Items to work-pack
    addTaggedItem(activityPackId: any, taggedItems): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.paramApi}/activitypacktaggeditems/${activityPackId}`, taggedItems, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //method for adding  activity tagged-items
    addActivitypacktaggeditems(activityPackId: string, taggeditems: any): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.paramApi}activitypacktaggeditems/${activityPackId}`, taggeditems, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //method for updating  activity tagged-items
    updateActivitypacktaggeditems(activityPackId: string, taggeditems: any): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.paramApi}activitypacktaggeditems/${activityPackId}`, taggeditems, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // method for updating  Move ActivityPack
    MoveActivitypack(payload): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.paramApi}activitypacks/move`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //method for adding  activitypacktaggeditem- activities
    postactivitypacktaggeditem(payload): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.paramApi}activitypacktaggeditemactivities`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //method for move to complete stage activitypacktaggeditem- activities
    completeActivitypacktaggeditem(payload): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.paramApi}activitypacktaggeditems/complete`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //method for getting details of the activitypacktaggeditem activities
    getactivitypacktaggeditemactivities(activityPackTaggedItemActivityId): Observable<APIRes<AddactivityPackTaggedItemActivity>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.paramApi}/activitypacktaggeditemactivities/${activityPackTaggedItemActivityId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //method for updating details of the activitypacktaggeditem activities
    putactivitypacktaggeditemactivities(payload): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.paramApi}activitypacktaggeditemactivities`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to create new  tagged items ************************** */
    postLeakOrException(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.paramApi}activitypacks`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to update Leak and Exception ************************** */
    putLeakOrException(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.paramApi}activitypacks`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to close Leak and Exception  ************************** */
    putLeakOrExceptionComplete(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();

        return this.http
            .put(`${this.paramApi}activitypacktaggeditems/complete`, params, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    searchActivityPackOfProject(payload: any): Observable<APIRes<{ total: number; data: SearchedProject[] }>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceId', `${localStorage.getItem('currentInstanceId')}`);
        return this.http
            .post(`${this.paramApi}activitypacks/searchactivitypacks`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    private handleError(error: any) {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        let currOrg = localStorage.getItem('selectedOrgId');
        let currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.message);

            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            // this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            //this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        }
        // Return an observable with a user-facing error message.
        return throwError('Something bad happened; please try again later.');
    }
}
